import React, { FunctionComponent, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useAppDispatch } from '../../../../../App/Hooks/reduxHooks'
import { appointmentDelete } from '../../../../store/thunks/deleteAppointment'
import { IAppointmentFormSubmission, IRepeatDetails } from '../../../../types'
import { DeleteButtons } from '../DeleteButtons'
import { UpdateRepeatMessage } from '../UpdateRepeatMessage'

import {
  DeleteChecbkoxLabel,
  DeleteCheckbox,
  DeleteCheckboxContainer,
  DeleteMessageText,
} from './style'

interface IProps {
  appointmentUuid: string
  appointmentDateKey: string
  repeatDetails: IRepeatDetails | null
}

export const DeleteAppointment: FunctionComponent<IProps> = ({
  repeatDetails,
  appointmentUuid,
  appointmentDateKey,
}) => {
  const { t } = useTranslation()
  const [deleteFuture, setDeleteFuture] = useState<boolean>(false)
  const { handleSubmit } = useForm<IAppointmentFormSubmission>()
  const dispatch = useAppDispatch()

  const onSubmit = () => {
    dispatch(
      appointmentDelete({
        appointmentUuid,
        isDeleteFutureAppointments: deleteFuture,
        appointmentDateKey,
      }),
    )
    return null
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <UpdateRepeatMessage repeatDetails={repeatDetails} />
      <DeleteMessageText>
        {t('Are you sure you want to delete the appointment?')}
      </DeleteMessageText>
      <DeleteCheckboxContainer render={!!repeatDetails}>
        <DeleteCheckbox
          type="checkbox"
          checked={deleteFuture}
          onChange={() => setDeleteFuture(!deleteFuture)}
        />
        <DeleteChecbkoxLabel>
          {t('Delete all future appointments')}
        </DeleteChecbkoxLabel>
      </DeleteCheckboxContainer>
      <DeleteButtons />
    </form>
  )
}
